import style from '../../component/common/style/index.scss';
import { Tooltip } from './../../component/common/ToolTip/ToolTip';
const gradeScale = ['Group', 'Year'];
function statuscellClass(params) {
    return (params.value == 'Below') ? [style.fontCls, style.raRed].join(" ") : [ style.fontCls].join(" ");
}
function statuscellClassColorblind(params) {
    return (params.value == 'Below') ? [style.fontCls, style.raRedcolorblind].join(" ") : [style.fontCls].join(" ");
}
function groupRowclass(params) {

    return (gradeScale.some(item => params.data.gradeType === item)) ? [style.groupedRow,style.top_cls].join(' ') : "";
}
// function colSpanclass(params) {
//     return (gradeScale.some(item => params.data.gradeType === item)) ? 2 : 1;
// }
function customTooltip(description) {
    let tooltip=[];
    tooltip.description = description;
    tooltip.tags=[];
    return Tooltip(tooltip);
}
let defaultConfig = {
    columnsdef: [
        {
            headerName: "First name",
             field: "firstName",
               sortable: true,
               minWidth: 200, 
               unSortIcon: true,
               sortingOrder: ['asc'] ,
                wrapText: true,
                autoHeight: true,
            //    cellClass: style.uIdcolumn, 
              // checkboxSelection: true,
               cellRenderer: (params) => {
                   let id = params.data.id;
                   let name = params.data.firstName;

                   return `<a href=/student/${id}  class="uIdcolumn" >${name}</a>`;

               }
        },
        {
            headerName: "Last name",
            sort: 'asc',
              field: "lastName",
               sortable: true, 
               unSortIcon: true,
               sortingOrder: ['asc', null],
               minWidth: 200,
               wrapText: true,
               autoHeight: true,
               cellClass: groupRowclass,
                cellRenderer: (params) => {
                    let id = params.data.id;
                    let name = params.data.lastName;
                    let classes = groupRowclass(params);
                    let template = (gradeScale.some(item => params.data.gradeType === item)) ? `<span class=${classes}>${name}</span>` : `<a href=/student/${id}  class="uIdcolumn" >${name}</a>`
                    return template;

                }
        },
        {
            headerName: "Indicative grade", autoHeight: true, field: "indicativeGrade", sortable: true, sortingOrder: ['asc'],unSortIcon: true,minWidth: 170, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "Steps", autoHeight: true, field: "steps", minWidth: 156, sortable: true, sortingOrder: ['asc'], unSortIcon: true, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "Mark", autoHeight: true, field: "mark", minWidth: 120, sortable: true, sortingOrder: ['asc'], unSortIcon: true, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "Percentage %", autoHeight: true,field: "percentage", sortable: true, sortingOrder: ['asc'], unSortIcon: true, minWidth: 148, cellClass: [style.centerCls, style.fontCls].join(" "),
            valueGetter(a){
                return `${a.data.percentage} %`
            }
        },
        {
            headerName: "Course target", autoHeight: true, field: "courseTarget", sortable: true, sortingOrder: ['asc'], unSortIcon: true, minWidth: 148, cellClass: [style.centerCls, style.fontCls].join(" ")
        },
        {
            headerName: "On track?", field: "onTrack",
             minWidth: 149, 
             cellClass: statuscellClass,
             autoHeight: true,
            headerTooltip: customTooltip(`This assessment result indicates the student is ‘on or above’ or ‘below’ track to meet their course target.
                    Based on linear progress from baseline to course target (excluding unit tests).`),
            headerComponentParams: {
                menuIcon: 'fa-bars',
                template:
                '<div class="ag-cell-label-container" role="presentation">' +
                '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
                '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
                '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>' +
                '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>' +
                '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>' +
                '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>' +
                '    <span ref="eText" class="ag-header-cell-text" role="columnheader"></span>  &nbsp;' +
                '    <span ref="eText" class="question-tooltip-icon question-tooltip-paddingWidget" role="columnheader"></span>' +
                '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
                '  </div>' +
                '</div>'
            },
            cellRenderer: (params) => {
                let id = params.data.id;

                let onTrack = (params.data.onTrack != null && params.data.onTrack != '') ? params.data.onTrack:'';  
  
                let template = (gradeScale.some(item => params.data.gradeType === item) && onTrack!='') ? `<span >${onTrack} student${onTrack <= 1 ? '' : 's'}<br/> on or above</span>` : `<span >${onTrack} </span>`             

                return template ;
            }

        },

    ],
    
};

export default defaultConfig;



export const convertColumndef = (isColorblind, viewBy, gradeConfig) => {

    let columnsArray = [];
    let removeColumn = (viewBy == 'indicativeGrade') ? 'steps' : 'indicativeGrade';
    let dynamicColumn = (viewBy == 'indicativeGrade') ? 'courseTargetGrade' : 'courseTargetStep';
    gradeConfig.columnsdef.map((val)=>{
        if (val['field'] != removeColumn){
            if (val['field'] =='onTrack'){
                val['cellClass'] = (isColorblind==true) ? statuscellClassColorblind : statuscellClass;
            }
            if (val['headerName'] == 'Course target'){
                val['field'] = dynamicColumn;
            }
            columnsArray.push(val)
        }       
    })
    return columnsArray;
}

export const convertRowData = (gradeConfig) => {
    
    let rowsArray = [],pinnedTopRow=[];
    gradeConfig.averageDataStudents.map((val) => {
        val.rowHeight=76;
        pinnedTopRow.push(val);
    })
    gradeConfig.gradeDataStudents.map((val) => {
        val.rowHeight = 38;
       rowsArray.push(val);
    })
    return { rowsArray: rowsArray, pinnedTopRow: pinnedTopRow};
}